import {useContext} from 'react'

import PropTypes from 'prop-types'

import AtomButton, {atomButtonShapes} from '@s-ui/react-atom-button'
import Context from '@s-ui/react-context'
import MoleculeNotification, {
  moleculeNotificationAlignItems,
  moleculeNotificationAutoClose,
  moleculeNotificationBorderSizes,
  moleculeNotificationTypes
} from '@s-ui/react-molecule-notification'
import {useRouter} from '@s-ui/react-router'
import {AuthenticationContext} from '@adv-mt/mt-context-authentication'
import {useAnalyticsTrack} from '@adv-mt/mt-tracking-use-analytics'

const BASE_CLASS_NAME = 'mt-NotificationsDiscardDraft'
const TEXT_CLASS_NAME = `${BASE_CLASS_NAME}Text`

const NotificationsDiscardDraft = ({
  adId,
  categoryId,
  handleOnClick,
  text,
  alignItems = moleculeNotificationAlignItems.FLEX_START
} = {}) => {
  const {domain, i18n} = useContext(Context)
  const {user} = useContext(AuthenticationContext)
  const {track} = useAnalyticsTrack()

  const router = useRouter()

  const config = domain.get('config')
  const {PUBLISH_MY_AD_PATH_PATTERN} = config.get('page')

  const _handleOnClick = () => {
    if (handleOnClick) {
      handleOnClick()
      return
    }

    track({
      // ff_web_seller_show_pta_multitenant
      // TO DO: move getting track data to domain
      event: 'Ad Draft Deleted'
    })

    domain
      .get('discard_draft_ad_publisher_use_case')
      .execute({
        adId,
        categoryId,
        userId: user?.userId
      })
      .then(() => router.push(PUBLISH_MY_AD_PATH_PATTERN))
  }

  return (
    <MoleculeNotification
      autoClose={moleculeNotificationAutoClose.manual}
      type={moleculeNotificationTypes.system}
      showCloseButton={false}
      roundedCorners={moleculeNotificationBorderSizes.medium}
      alignItems={alignItems}
    >
      <div className={BASE_CLASS_NAME}>
        <p className={TEXT_CLASS_NAME}>{text ?? i18n.t('PUBLISH_AD.DISCARD.LABEL')}</p>
        {adId && (
          <div>
            <AtomButton negative type="primary" onClick={_handleOnClick} shape={atomButtonShapes.CIRCULAR}>
              {i18n.t('PUBLISH_AD.DISCARD.BUTTON')}
            </AtomButton>
          </div>
        )}
      </div>
    </MoleculeNotification>
  )
}

NotificationsDiscardDraft.displayName = 'NotificationsDiscardDraft'
NotificationsDiscardDraft.propTypes = {
  adId: PropTypes.string,
  categoryId: PropTypes.string,
  handleOnClick: PropTypes.func,
  text: PropTypes.string,
  alignItems: PropTypes.string
}

export default NotificationsDiscardDraft
